/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { Row, Col, Form, Container } from 'reactstrap';
import Checkbox from 'react-three-state-checkbox';
import Icon from '../../../common/containers/icon';
const OptionNestedPickerFieldOptions = _ref => {
  let options = _ref.options,
    onSelect = _ref.onSelect,
    onForwardSelect = _ref.onForwardSelect,
    showIcon = _ref.showIcon,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$showCheck = _ref.showCheck,
    showCheck = _ref$showCheck === void 0 ? true : _ref$showCheck;
  return /*#__PURE__*/React.createElement(Container, {
    style: {
      maxHeight: 500,
      overflow: 'auto',
      paddingTop: 10,
      paddingBottom: 10
    }
  }, /*#__PURE__*/React.createElement(Form, null, options.map((option, index) => /*#__PURE__*/React.createElement("span", {
    key: option.identifier
  }, /*#__PURE__*/React.createElement(Row, {
    className: "t-onpo-".concat(className, " t-onpo-").concat(kebabCase(option.title)),
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Col, {
    md: option.hasChildren ? 9 : 12,
    onClick: () => onSelect(option)
  }, showCheck && /*#__PURE__*/React.createElement(Checkbox, {
    className: "t-onpfo-checkbox-".concat(kebabCase(option.identifier)),
    "data-testid": "t-onpfo-checkbox-".concat(kebabCase(option.identifier)),
    style: {
      marginRight: 5
    },
    checked: option._isSelected
  }), /*#__PURE__*/React.createElement("span", null, option.title)), option.hasChildren ? /*#__PURE__*/React.createElement(Col, {
    md: 3,
    className: "t-onpo-forward-".concat(kebabCase(option.title)),
    style: {
      textAlign: 'right'
    },
    onClick: () => onForwardSelect(option)
  }, showIcon && option._isSelected ? /*#__PURE__*/React.createElement(Icon, {
    glyph: "info-circle"
  }) : null, /*#__PURE__*/React.createElement(Icon, {
    glyph: "chevron-right"
  })) : null), option._crumbs || option.subtitle ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement("small", null, option.subtitle || option._crumbs))) : null, index === options.length - 1 ? undefined : /*#__PURE__*/React.createElement("hr", {
    style: {
      marginTop: 5,
      marginBottom: 5
    }
  })))));
};
OptionNestedPickerFieldOptions.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelect: PropTypes.func.isRequired,
  onForwardSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
  showIcon: PropTypes.bool.isRequired,
  showCheck: PropTypes.bool
};
export default OptionNestedPickerFieldOptions;